module.exports = __webpack_public_path__ + "images/backgrounds/fall/small.8c8e3c5c5eebeac446c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/fall/small.jpg
// module id = 8FUd
// module chunks = 2